"use strict"; // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var _slicedToArray = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var common_1 = require("../../common");

var Graphics = require("../../graphics");

var solver_1 = require("../../solver");

var Specification = require("../../specification");

var emphasis_1 = require("./emphasis");

var nested_chart_attrs_1 = require("./nested_chart.attrs");

var NestedChartElementClass =
/*#__PURE__*/
function (_emphasis_1$Emphasiza) {
  _inherits(NestedChartElementClass, _emphasis_1$Emphasiza);

  function NestedChartElementClass() {
    var _this;

    _classCallCheck(this, NestedChartElementClass);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NestedChartElementClass).apply(this, arguments));
    _this.attributes = nested_chart_attrs_1.nestedChartAttributes;
    _this.attributeNames = Object.keys(nested_chart_attrs_1.nestedChartAttributes);
    return _this;
  } // Initialize the state of an element so that everything has a valid value


  _createClass(NestedChartElementClass, [{
    key: "initializeState",
    value: function initializeState() {
      _get(_getPrototypeOf(NestedChartElementClass.prototype), "initializeState", this).call(this);

      var defaultWidth = 30;
      var defaultHeight = 50;
      var attrs = this.state.attributes;
      attrs.x1 = -defaultWidth / 2;
      attrs.y1 = -defaultHeight / 2;
      attrs.x2 = +defaultWidth / 2;
      attrs.y2 = +defaultHeight / 2;
      attrs.cx = 0;
      attrs.cy = 0;
      attrs.width = defaultWidth;
      attrs.height = defaultHeight;
      attrs.opacity = 1;
      attrs.visible = true;
    }
  }, {
    key: "getAttributePanelWidgets",
    value: function getAttributePanelWidgets(manager) {
      var widgets = [manager.sectionHeader("Size & Shape"), manager.mappingEditor("Width", "width", {
        hints: {
          autoRange: true,
          startWithZero: "always"
        },
        acceptKinds: [Specification.DataKind.Numerical],
        defaultAuto: true
      }), manager.mappingEditor("Height", "height", {
        hints: {
          autoRange: true,
          startWithZero: "always"
        },
        acceptKinds: [Specification.DataKind.Numerical],
        defaultAuto: true
      })];
      widgets = widgets.concat([manager.mappingEditor("Opacity", "opacity", {
        hints: {
          rangeNumber: [0, 1]
        },
        defaultValue: 1,
        numberOptions: {
          showSlider: true,
          minimum: 0,
          maximum: 1
        }
      }), manager.mappingEditor("Visibility", "visible", {
        defaultValue: true
      })]);
      widgets = widgets.concat([manager.nestedChartEditor({
        property: "specification"
      }, {
        specification: this.object.properties.specification,
        dataset: this.getDataset(0),
        width: this.state.attributes.width,
        height: this.state.attributes.height
      })]);
      return widgets;
    } // Get intrinsic constraints between attributes (e.g., x2 - x1 = width for rectangles)

  }, {
    key: "buildConstraints",
    value: function buildConstraints(solver) {
      var _solver$attrs = solver.attrs(this.state.attributes, ["x1", "y1", "x2", "y2", "cx", "cy", "width", "height"]),
          _solver$attrs2 = _slicedToArray(_solver$attrs, 8),
          x1 = _solver$attrs2[0],
          y1 = _solver$attrs2[1],
          x2 = _solver$attrs2[2],
          y2 = _solver$attrs2[3],
          cx = _solver$attrs2[4],
          cy = _solver$attrs2[5],
          width = _solver$attrs2[6],
          height = _solver$attrs2[7];

      solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, x2], [-1, x1]], [[1, width]]);
      solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[1, y2], [-1, y1]], [[1, height]]);
      solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[2, cx]], [[1, x1], [1, x2]]);
      solver.addLinear(solver_1.ConstraintStrength.HARD, 0, [[2, cy]], [[1, y1], [1, y2]]);
    }
  }, {
    key: "getDataset",
    value: function getDataset(glyphIndex) {
      var manager = this.getChartClass().manager;
      var plotSegmentClass = this.getPlotSegmentClass();
      var table = common_1.getByName(manager.dataset.tables, plotSegmentClass.object.table);
      var columnNameMap = this.object.properties.columnNameMap;

      if (columnNameMap == null) {
        columnNameMap = {};
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = table.columns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var c = _step.value;
            columnNameMap[c.name] = c.name;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        this.object.properties.columnNameMap = columnNameMap;
      }

      var dataRows = plotSegmentClass.state.dataRowIndices[glyphIndex].map(function (i) {
        var data = table.rows[i];
        var r = {
          _id: data._id
        };

        for (var col in columnNameMap) {
          r[columnNameMap[col]] = data[col];
        }

        return r;
      });
      return {
        name: "NestedData",
        tables: [{
          name: "MainTable",
          displayName: "MainTable",
          columns: table.columns.map(function (x) {
            return {
              name: columnNameMap[x.name],
              type: x.type,
              metadata: x.metadata
            };
          }),
          rows: dataRows
        }]
      };
    } // Get the graphical element from the element

  }, {
    key: "getGraphics",
    value: function getGraphics(cs, offset) {
      var glyphIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var manager = arguments.length > 3 ? arguments[3] : undefined;
      var empasized = arguments.length > 4 ? arguments[4] : undefined;
      var attrs = this.state.attributes;

      if (!attrs.visible || !this.object.properties.visible) {
        return null;
      }

      var g = Graphics.makeGroup([{
        type: "chart-container",
        dataset: this.getDataset(glyphIndex),
        chart: common_1.deepClone(this.object.properties.specification),
        selectable: {
          plotSegment: this.getPlotSegmentClass().object,
          glyphIndex: glyphIndex,
          rowIndices: this.getPlotSegmentClass().state.dataRowIndices[glyphIndex]
        },
        width: attrs.width,
        height: attrs.height
      }]);
      g.transform = {
        angle: 0,
        x: -attrs.width / 2,
        y: attrs.height / 2
      };
      var gContainer = Graphics.makeGroup([g]);
      gContainer.transform = cs.getLocalTransform(attrs.cx + offset.x, attrs.cy + offset.y);
      return gContainer;
    } // Get DropZones given current state

  }, {
    key: "getDropZones",
    value: function getDropZones() {
      var attrs = this.state.attributes;
      var x1 = attrs.x1,
          y1 = attrs.y1,
          x2 = attrs.x2,
          y2 = attrs.y2;
      return [{
        type: "line",
        p1: {
          x: x2,
          y: y1
        },
        p2: {
          x: x1,
          y: y1
        },
        title: "width",
        accept: {
          kind: Specification.DataKind.Numerical
        },
        dropAction: {
          scaleInference: {
            attribute: "width",
            attributeType: Specification.AttributeType.Number,
            hints: {
              autoRange: true,
              startWithZero: "always"
            }
          }
        }
      }, {
        type: "line",
        p1: {
          x: x1,
          y: y1
        },
        p2: {
          x: x1,
          y: y2
        },
        title: "height",
        accept: {
          kind: Specification.DataKind.Numerical
        },
        dropAction: {
          scaleInference: {
            attribute: "height",
            attributeType: Specification.AttributeType.Number,
            hints: {
              autoRange: true,
              startWithZero: "always"
            }
          }
        }
      }];
    } // Get bounding rectangle given current state

  }, {
    key: "getHandles",
    value: function getHandles() {
      var attrs = this.state.attributes;
      var x1 = attrs.x1,
          y1 = attrs.y1,
          x2 = attrs.x2,
          y2 = attrs.y2;
      return [{
        type: "line",
        axis: "x",
        actions: [{
          type: "attribute",
          attribute: "x1"
        }],
        value: x1,
        span: [y1, y2]
      }, {
        type: "line",
        axis: "x",
        actions: [{
          type: "attribute",
          attribute: "x2"
        }],
        value: x2,
        span: [y1, y2]
      }, {
        type: "line",
        axis: "y",
        actions: [{
          type: "attribute",
          attribute: "y1"
        }],
        value: y1,
        span: [x1, x2]
      }, {
        type: "line",
        axis: "y",
        actions: [{
          type: "attribute",
          attribute: "y2"
        }],
        value: y2,
        span: [x1, x2]
      }, {
        type: "point",
        x: x1,
        y: y1,
        actions: [{
          type: "attribute",
          source: "x",
          attribute: "x1"
        }, {
          type: "attribute",
          source: "y",
          attribute: "y1"
        }]
      }, {
        type: "point",
        x: x1,
        y: y2,
        actions: [{
          type: "attribute",
          source: "x",
          attribute: "x1"
        }, {
          type: "attribute",
          source: "y",
          attribute: "y2"
        }]
      }, {
        type: "point",
        x: x2,
        y: y1,
        actions: [{
          type: "attribute",
          source: "x",
          attribute: "x2"
        }, {
          type: "attribute",
          source: "y",
          attribute: "y1"
        }]
      }, {
        type: "point",
        x: x2,
        y: y2,
        actions: [{
          type: "attribute",
          source: "x",
          attribute: "x2"
        }, {
          type: "attribute",
          source: "y",
          attribute: "y2"
        }]
      }];
    }
  }, {
    key: "getBoundingBox",
    value: function getBoundingBox() {
      var attrs = this.state.attributes;
      var x1 = attrs.x1,
          y1 = attrs.y1,
          x2 = attrs.x2,
          y2 = attrs.y2;
      return {
        type: "rectangle",
        cx: (x1 + x2) / 2,
        cy: (y1 + y2) / 2,
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1),
        rotation: 0
      };
    }
  }, {
    key: "getSnappingGuides",
    value: function getSnappingGuides() {
      var attrs = this.state.attributes;
      var x1 = attrs.x1,
          y1 = attrs.y1,
          x2 = attrs.x2,
          y2 = attrs.y2,
          cx = attrs.cx,
          cy = attrs.cy;
      return [{
        type: "x",
        value: x1,
        attribute: "x1"
      }, {
        type: "x",
        value: x2,
        attribute: "x2"
      }, {
        type: "x",
        value: cx,
        attribute: "cx"
      }, {
        type: "y",
        value: y1,
        attribute: "y1"
      }, {
        type: "y",
        value: y2,
        attribute: "y2"
      }, {
        type: "y",
        value: cy,
        attribute: "cy"
      }];
    }
  }, {
    key: "getTemplateParameters",
    value: function getTemplateParameters() {
      return {
        inferences: [{
          objectID: this.object._id,
          dataSource: {
            table: this.getGlyphClass().object.table
          },
          nestedChart: {
            columnNameMap: this.object.properties.columnNameMap
          }
        }]
      };
    }
  }], [{
    key: "createDefault",
    value: function createDefault() {
      var _get2;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var obj = (_get2 = _get(_getPrototypeOf(NestedChartElementClass), "createDefault", this)).call.apply(_get2, [this].concat(args));

      var myGlyphID = common_1.uniqueID();
      var tableName = "MainTable";
      obj.properties.specification = {
        _id: common_1.uniqueID(),
        classID: "chart.rectangle",
        properties: {
          name: "Chart",
          backgroundColor: null,
          backgroundOpacity: 1
        },
        mappings: {
          marginTop: {
            type: "value",
            value: 25
          },
          marginBottom: {
            type: "value",
            value: 10
          },
          marginLeft: {
            type: "value",
            value: 10
          },
          marginRight: {
            type: "value",
            value: 10
          }
        },
        glyphs: [{
          _id: myGlyphID,
          classID: "glyph.rectangle",
          properties: {
            name: "Glyph"
          },
          table: tableName,
          marks: [{
            _id: common_1.uniqueID(),
            classID: "mark.anchor",
            properties: {
              name: "Anchor"
            },
            mappings: {
              x: {
                type: "parent",
                parentAttribute: "icx"
              },
              y: {
                type: "parent",
                parentAttribute: "icy"
              }
            }
          }],
          mappings: {},
          constraints: []
        }],
        elements: [{
          _id: common_1.uniqueID(),
          classID: "plot-segment.cartesian",
          glyph: myGlyphID,
          table: tableName,
          filter: null,
          mappings: {
            x1: {
              type: "parent",
              parentAttribute: "x1"
            },
            y1: {
              type: "parent",
              parentAttribute: "y1"
            },
            x2: {
              type: "parent",
              parentAttribute: "x2"
            },
            y2: {
              type: "parent",
              parentAttribute: "y2"
            }
          },
          properties: {
            name: "PlotSegment1",
            visible: true,
            marginX1: 0,
            marginY1: 0,
            marginX2: 0,
            marginY2: 0,
            sublayout: {
              type: "dodge-x",
              order: null,
              ratioX: 0.1,
              ratioY: 0.1,
              align: {
                x: "start",
                y: "start"
              },
              grid: {
                direction: "x",
                xCount: null,
                yCount: null
              }
            }
          }
        }, {
          _id: common_1.uniqueID(),
          classID: "mark.text",
          properties: {
            name: "Title",
            visible: true,
            alignment: {
              x: "middle",
              y: "top",
              xMargin: 0,
              yMargin: 5
            },
            rotation: 0
          },
          mappings: {
            x: {
              type: "parent",
              parentAttribute: "cx"
            },
            y: {
              type: "parent",
              parentAttribute: "oy2"
            },
            text: {
              type: "value",
              value: "Nested Chart"
            },
            fontSize: {
              type: "value",
              value: 12
            },
            color: {
              type: "value",
              value: {
                r: 0,
                g: 0,
                b: 0
              }
            }
          }
        }],
        scales: [],
        constraints: [],
        resources: []
      };
      return obj;
    }
  }]);

  return NestedChartElementClass;
}(emphasis_1.EmphasizableMarkClass);

NestedChartElementClass.classID = "mark.nested-chart";
NestedChartElementClass.type = "mark";
NestedChartElementClass.metadata = {
  displayName: "NestedChart",
  iconPath: "mark/nested-chart",
  creatingInteraction: {
    type: "rectangle",
    mapping: {
      xMin: "x1",
      yMin: "y1",
      xMax: "x2",
      yMax: "y2"
    }
  }
};
NestedChartElementClass.defaultProperties = {
  visible: true
};
NestedChartElementClass.defaultMappingValues = {
  opacity: 1,
  visible: true
};
exports.NestedChartElementClass = NestedChartElementClass;